import { IStoreSupportFaqItem } from '@gn-audio/core/api/store-support/models/store-support-faq-item';
import { fetchFAQs } from '@gn-audio/core/api/store-support/fetch-faqs';

export interface ICategoryFaqsBaseComponent {
    getFaqs(categoryKey: string): ng.IPromise<IStoreSupportFaqItem[] | null>;
  }

export class CategoryFaqsBaseComponent implements ICategoryFaqsBaseComponent {
    public loading = true;
  
    constructor(protected $q: ng.IQService) {
    }
  
    public getFaqs(categoryKey: string): ng.IPromise<IStoreSupportFaqItem[] | null> {
      return this.$q
        .when(fetchFAQs(categoryKey))
        .then((items: IStoreSupportFaqItem[] | null): IStoreSupportFaqItem[] | null => {
           return items;
        });
    }
}